import React from "react";

export const DownloadIcon = (props) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6803_21078)">
        <path
          d="M2.16675 8.5V9.5C2.16675 9.76522 2.28088 10.0196 2.48405 10.2071C2.68721 10.3946 2.96276 10.5 3.25008 10.5H9.75008C10.0374 10.5 10.3129 10.3946 10.5161 10.2071C10.7193 10.0196 10.8334 9.76522 10.8334 9.5V8.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.79175 5.5L6.50008 8L9.20841 5.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 2V8"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6803_21078">
          <rect width="13" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
